module.exports = __webpack_public_path__ + "static/media/ArosaLenz_Slider_2.8e90b252.jpg";